module.exports = __webpack_public_path__ + "static/media/solarisbank.4296ecd8.png";